import { appBaseUrl } from "@/variables"

import { CartClient } from "@/lib/api"


const initialState = () => ({
    api: new CartClient(appBaseUrl),
    cart: {},
    showDonateDialog: false,
    cartItemsDictionary:{}
});

// State object
const state = {
    api: new CartClient(appBaseUrl),
    cart: {},
    showDonateDialog: false,
    cartItemsDictionary:{}
}

// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },
    cart(state) {
        return state.cart;
    },
    showDonateDialog(state) {
        return state.showDonateDialog;
    },
    cartItemsDictionary(state) {
        return state.cartItemsDictionary;
    },
}

// Actions 
const actions = {
    async loadCart({state, commit}){
        const response = await state.api.cart();

        commit('loadCartCompleted', response);
    },
 
    async addItem({state, commit},  {cartId, quantity, itemId, amount}){

        let model = {
            cartId: cartId,
            quantity : quantity,
            itemId : itemId,
            amount : amount,
            language: 'ar'
        }

        await state.api.addItem(model);

        const response = await state.api.cart();

        commit('loadCartCompleted', response);

    },

    async removeItem({state, commit},  {cartId, lineItemId}){

        let model = {
            cartId: cartId,
            lineItemId : lineItemId,
            language: 'ar'
        }

        await state.api.removeItem(model);

        const response = await state.api.cart();

        commit('loadCartCompleted', response);

    },

    async updateQuantity({state, commit},  {cartId, lineItemId, quantity}){

        let model = {
            cartId: cartId,
            lineItemId : lineItemId,
            quantity: quantity,
            language: 'ar'
        }

        await state.api.updateQuantity(model);

        const response = await state.api.cart();

        commit('loadCartCompleted', response);

    },

    showDonate({ commit}){
        commit('showDonateCompleted');
    },

    dismissDonate({ commit}){
        commit('dismissDonateCompleted');
    }
}

// Mutations
const mutations = {

    loadCartCompleted(state, cart){
        state.cart = cart
        state.cartItemsDictionary = cart.lineItems.reduce(function(map, obj) {
                map[obj.originalItemId] = true;
                return map;
            }, {});
       
    },

    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        let token = window.localStorage.getItem('token') || ""
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    },

    showDonateCompleted(state){
        state.showDonateDialog = true;
    },

    dismissDonateCompleted(state){
        state.showDonateDialog = false;
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}